import { render, staticRenderFns } from "./add-form.vue?vue&type=template&id=a756b67c&scoped=true"
import script from "./add-form.vue?vue&type=script&setup=true&lang=js"
export * from "./add-form.vue?vue&type=script&setup=true&lang=js"
import style0 from "./add-form.vue?vue&type=style&index=0&id=a756b67c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a756b67c",
  null
  
)

export default component.exports